import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
/**
 * Colunas da tabela de pedidos usando TanStack Table
 */

export const getPedidosColumns = (handleEditar, handleExcluir) => [{
  id: 'numeroDoPedido',
  header: 'Número do Pedido',
  accessorKey: 'numeroDoPedido',
  size: 150,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={15} />
}, {
  id: 'numeroDaCarga',
  header: 'Número da Carga',
  accessorKey: 'numeroDaCarga',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'tipoDaOperacao',
  header: 'Tipo da Operação',
  accessorKey: 'tipoDaOperacao',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => {
    const tipo = getValue();

    if (!tipo || tipo === '') {
      return <span style={{
        color: '#999'
      }}>-</span>;
    } // Se for um hash/ID criptografado, mostrar de forma diferente


    if (tipo.length > 20) {
      return <Tooltip dir="top" text={tipo}>
            <div style={{
          cursor: 'pointer'
        }}>
              <span style={{
            color: '#666',
            fontSize: '11px'
          }}>
                ID: {tipo.substring(0, 8)}...
              </span>
            </div>
          </Tooltip>;
    }

    return <TruncatedText value={tipo} maxLength={15} />;
  }
}, {
  id: 'origem',
  header: 'Origem',
  accessorKey: 'origem',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'destino',
  header: 'Destino',
  accessorKey: 'destino',
  size: 120,
  enableSorting: true,
  cell: ({
    getValue
  }) => <TruncatedText value={getValue()} maxLength={12} />
}, {
  id: 'localPalletizacao',
  header: 'Local de Palletização',
  accessorKey: 'localPalletizacao',
  size: 160,
  enableSorting: true,
  cell: ({
    getValue
  }) => {
    const local = getValue();

    if (!local || local === '' || local === 'Local não informado!') {
      return <span style={{
        color: '#999',
        fontStyle: 'italic'
      }}>Não informado</span>;
    }

    return <TruncatedText value={local} maxLength={18} />;
  }
}, {
  id: 'dataAgendamento',
  header: 'Data de Agendamento',
  accessorKey: 'dataAgendamento',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}, {
  id: 'dataIntegracao',
  header: 'Data de Integração',
  accessorKey: 'dataIntegracao',
  size: 140,
  enableSorting: true,
  cell: ({
    getValue
  }) => <span>{getValue()}</span>
}, {
  id: 'ctes',
  header: 'CTEs',
  accessorKey: 'ctes',
  size: 150,
  enableSorting: false,
  cell: ({
    getValue
  }) => {
    const ctes = getValue();

    if (!ctes || ctes === '') {
      return <span style={{
        color: '#999'
      }}>-</span>;
    }

    const ctesArray = ctes.split(',').map(cte => cte.trim());
    const displayText = ctesArray.length > 1 ? `${ctesArray.length} CTEs` : ctes;
    return <Tooltip dir="top" text={ctes}>
          <div style={{
        cursor: 'pointer'
      }}>
            <TruncatedText value={displayText} maxLength={20} />
          </div>
        </Tooltip>;
  }
}, {
  id: 'notasFiscais',
  header: 'NFs',
  accessorKey: 'notasFiscais',
  size: 150,
  enableSorting: false,
  cell: ({
    getValue
  }) => {
    const nfs = getValue();

    if (!nfs || nfs === '') {
      return <span style={{
        color: '#999'
      }}>-</span>;
    }

    const nfsArray = nfs.split(',').map(nf => nf.trim());
    const displayText = nfsArray.length > 1 ? `${nfsArray.length} NFs` : nfs;
    return <Tooltip dir="top" text={nfs}>
          <div style={{
        cursor: 'pointer'
      }}>
            <TruncatedText value={displayText} maxLength={20} />
          </div>
        </Tooltip>;
  }
} // Coluna de ações removida conforme solicitado
];
